import { routes } from "../routes/Routes";

export const GLOBAL_ADMIN_ROLE_ID = 1;
export const ADMIN_ROLE_ID = 2;
export const INFO_MODULE = "Information";


export const genderData = [
  { label: "Male", value: "Male", id: 1 },
  { label: "Female", value: "Female", id: 2 }
];
export const states = ['California', 'Oklahoma', 'Texas'];
export const trustTypes = [
  { value: 'revocable', label: 'Revocable Trust' },
  { value: 'irrevocable', label: 'Irrevocable Trust' },
];
export const mortageType = [
  { value: 'mortgage type1', label: 'mortgage type1' },
  { value: 'mortgage type2', label: 'mortgage type2' },
  { value: 'mortgage type3', label: 'mortgage type3' },
];
export const applicationType = [
  { value: 'Borrower', label: 'Borrower' },
  { value: 'Trust', label: 'Trust' },
  { value: 'Borrower & Co-Borrower (Trust)', label: 'Borrower & Co-Borrower (Trust)' },
  { value: 'Borrower & Co-Borrower', label: 'Borrower & Co-Borrower' },
];

// export const applicationStatus = [
//   { id: 1, name: "New", buttonName: "Complete & Submit", color: "#FFF9E6", textColor: "#B26A00" }, // Light Yellow / Amber
//   { id: 2, name: "Submitted", buttonName: "View Application", color: "#E0F7FA", textColor: "#00796B" }, // Light Cyan / Teal
//   { id: 3, name: "Under Review", buttonName: "View Application", color: "#E3F2FD", textColor: "#1565C0" }, // Light Blue / Blue
//   { id: 4, name: "Revision Requested", buttonName: "Edit & Resubmit", color: "#FFF3E0", textColor: "#EF6C00" }, // Light Orange / Orange
//   { id: 5, name: "Action Required", buttonName: "Complete & Resubmit", color: "#F3E5F5", textColor: "rgb(195 5 5)" }, // Lavender / Purple
//   { id: 6, name: "Resubmitted", buttonName: "View Application", color: "#EDE7F6", textColor: "#5E35B1" }, // Pale Violet / Indigo
//   { id: 7, name: "Recommend", buttonName: "View Application", color: "#E8EAF6", textColor: "#3949AB" }, //  Light Indigo / Indigo
//   { id: 8, name: "Approved", buttonName: "View Application", color: "#E8F5E9", textColor: "#2E7D32" }, // Light Green / Green
//   { id: 9, name: "Rejected", buttonName: "View Application", color: "#FFEBEE", textColor: "rgb(255 0 0)" }, // Light Pink / Red
//   { id: 10, name: "Loan Officer Review", buttonName: "View Application", color: "#E3F2FD", textColor: "#1565C0" } // Light Blue / Blue
// ];

export const applicationStatus = [
  { id: 1, name: "Draft", buttonName: "Complete & Submit", color: "#F59E0B1A", textColor: "#F59E0B" }, // Light Yellow / Amber
  { id: 2, name: "Submitted", buttonName: "View Application", color: "rgba(34, 197, 94, 0.10)", textColor: "rgba(74, 222, 128, 1)" }, // Light Cyan / Teal
  { id: 3, name: "Under Review Admin", buttonName: "View Application", color: "#3B82F61A", textColor: "#3B82F6" }, // Light Blue / Blue
  { id: 4, name: "Qualified", buttonName: "View Application", color: "#F59E0B1A", textColor: "#B26A00" }, // Light Orange / Orange
  { id: 5, name: "Not Qualified", buttonName: "View Application", color: "#F3E5F5", textColor: "rgb(195 5 5)" }, // Lavender / Purple
  { id: 6, name: "Action Required", buttonName: "View & Resubmit", color: "rgba(245, 158, 11, 0.10)", textColor: "rgba(245, 158, 11, 1)" }, // Pale Violet / Indigo
  { id: 7, name: "Under Review Capital Provider", buttonName: "View Application", color: "rgba(59, 130, 246, 0.10)", textColor: "#1565C0" }, //  Light Indigo / Indigo
  { id: 8, name: "Funded", buttonName: "View Application", color: "rgba(65, 116, 110, 0.10)", textColor: "#41746E" }, // Mint Light Green, // Deep Teal-Green 
  { id: 9, name: "Funded", buttonName: "View Application", color: "#E8F5E9", textColor: "#2E7D32" }, // Light Green / Green
  { id: 10, name: "Rejected", buttonName: "View Application", color: "rgba(248, 113, 113, 0.10)", textColor: "rgba(248, 113, 113, 1)" }, // Light Pink / Red
  { id: 11, name: "Resubmitted", buttonName: "View Application", color: "#EDE7F6", textColor: "#5E35B1" }, // Pale Violet / Indigo
  { id: 12, name: "Under Review By Administrator", buttonName: "View Application", color: "#E3F2FD", textColor: "#1565C0" }, // (if the application is reject or not qualified then it will show investor to under reivew admin)
  { id: 13, name: "PRE-QUALIFIED", buttonName: "View Application", color: "#F3E5F5", textColor: "#013220" }, //(if Isprequalify==true than use this status)
];

export const UnderReviewStatusId = 3;
export const CapitalProviderReviewStatusId = 7;
export const LoanOfficerReviewStatusId = 7;
export const DraftStatusId = 1;

export const ScreenNamebalancesheetasset = "balancesheetasset";
export const ScreenNameDashboard = "dashboard";
export const ScreenNamebalancesheettotalasset = "balancesheettotalasset";
export const ScreenNamebalancesheetliability = "balancesheetliability";


export const getPrivateRoutesByRole = () => ({
  consumer: [
    routes.newLiquidityApplication.path,
    routes.documentsUpload.path,
    routes.consumerDetailsDashboard.path,
    routes.financialStatementTabForConsumer.path,
    routes.incomeSourcesForConsumer.path,
    routes.expensesForConsumer.path,
    routes.balanceSheetAssetsForConsumer.path,
    routes.balanceSheetTotalAssetsForConsumer.path,
    routes.balanceSheetTotalLiabilitiesForConsumer.path,
    routes.questionnaireForConsumer.path,
    routes.consumerDashboard.path,
    routes.consumerMarketPlace.path,
    routes.consumerReports.path,
    routes.consumerInsightsReports.path,
    routes.consumerProfile.path,
    routes.consumerUploadDocumentsPreview.path,
    routes.createConsumerLoginPassword.path,
    routes.consumerPersonalDetails.path,
    routes.reportPreview.path,
    routes.consumerSecondaryMarketPlaceDetails.path,
    routes.applicationSubmitted.path
  ],
  administrator: [
    routes.createAdministratorLoginPassword.path,
    routes.administratorPersonalDetails.path,
    routes.administratorProfessionalDetails.path,
    routes.administratorProfile.path,
    routes.administratorDashboard.path,
    routes.sponsorsCapitalProvider.path,
    // routes.loanApplicationsForAdministrator.path,
    routes.addEditSponsersForAdministrator.path,
    routes.loanApplicationDetailsForAdministrator.path,
    routes.loanDetailsHeaderForAdministrator.path,
    routes.administratorReports.path,
    routes.dataInsightsForAdministrator.path,
    routes.reportPreview.path,

    
  ],
  capitalProvider: [
    routes.createCapitalProviderLoginPassword.path,
    routes.capitalProviderPersonalDetails.path,
    routes.capitalProviderProfessionalDetails.path,
    routes.capitalProviderDashboard.path,
    routes.capitalProviderProfile.path,
    // routes.loanApplicationsForCapitalProvider.path,
    routes.dataInsightsForCapitalProvider.path,
    routes.loanApplicationDetailsForAdministrator.path,
    routes.capitalProviderReports.path,
    routes.reportPreview.path,

  ]
  // client: [
  //   routes.ApplicantsDetails.path,
  //   routes.ProofOfTrust.path,
  //   routes.applicantsIdentification.path,
  //   routes.coBorrowersDetails.path,
  //   routes.identificationOfcoBorrower.path,
  //   routes.applicantProfessionalDetails.path,
  //   routes.uploaddocuments.path,
  //   routes.liquidity.path,
  //   routes.realestateassets.path,
  //   routes.businessAssets.path,
  //   routes.partnershipInterests.path,
  //   routes.personalHolding.path,
  //   routes.liabilitiesForm.path,
  //   routes.incomeSources.path,
  //   routes.expenses.path,
  //   routes.balanceSheetAssets.path,
  //   routes.balanceSheetTotalAssets.path,
  //   routes.balanceSheetTotalLiabilities.path,
  //   routes.questionnaire.path,
  //   routes.dashboard.path,
  //   routes.myApplications.path,
  //   routes.applicationStatus.path,
  //   routes.createNewPasswordForUser.path,
  //   routes.liveAccountBalances.path,
  //   routes.advancesAndRepayments.path,
  //   routes.dataInsights.path,
  //   routes.firmadminsponsersdetails
  // ],
  // banker: [
  //   routes.personalDetails.path,
  //   routes.professionalDetails.path,
  //   routes.loanapplication.path,
  //   routes.revisionrequest.path,
  //   routes.bankerdashboard.path,
  //   routes.bankerprofile.path,
  //   routes.sponsors.path,
  //   routes.addEditSponsers.path,
  //   routes.loanApplicationDetails.path,
  //   routes.createNewPasswordForBanker.path,
  //   routes.liveAccountBalancesForBanker.path,
  //   routes.advancesAndRepaymentsForBanker.path,
  //   routes.dataInsightsForBanker.path,
  // ],
  // loanOfficer: [
  //   routes.loanOfficerDashboard.path,
  //   routes.loanOfficerRevisionRequest.path,
  //   routes.loanApplicationDetails.path,
  //   routes.personalDetailsForLoanOfficer.path,
  //   routes.professionalDetailsForLoanOfficer.path,
  //   routes.createNewPasswordForLoanOfficer.path,
  //   routes.loanOfficerProfile.path,
  //   routes.loanApplicationsForLoanOfficer.path,
  //   routes.dataInsightsForBanker.path,
  // ],
  // bankadmin: [
  //   routes.bankadminpersonaldetails.path,
  //   routes.bankadminprofessionaldetails.path,
  //   routes.createbankadminpassword.path,
  //   routes.bankadmindashboard.path,
  //   routes.bankadminprofile.path,
  // ],
  // firmadmin: [
  //   routes.firmadmindashboard.path,
  // ]
});


export const ApplicationScreens = [
  { screenName: "Personal Details", statusKey: "IsAapplicationDetailsCompleted", url: "/new-liquidity-application" },
  // { screenName: "Proof Of Trust", statusKey: "IsProofofTrustCompleted", url: "/proof-of-trust" },
  // { screenName: "Identification Details", statusKey: "IsAapplicationIdentificationCompleted", url: "/applicant-identification" },
  // { screenName: "Cob Details", statusKey: "IsCoborrowerDetailsCompleted", url: "/co-BorrowersDetails" },
  // { screenName: "Cob Identification", statusKey: "IsCoborrowerIdentificationCompleted", url: "/identificationOfCo-Borrower" },
  { screenName: "Upload Documents", statusKey: "IsDocumentUploadCompleted", url: "/documents-upload" },
  { screenName: "Income Source", statusKey: "IsIncomesourceCompleted", url: "/income-sources-consumer" },
  { screenName: "Expenses", statusKey: "IsExpensesCompleted", url: "/expenses-consumer" },
  { screenName: "Balance Sheet Asset", statusKey: "IsBalancesheetAssetCompleted", url: "/balance-sheet-assets-consumer" },
  { screenName: "Balance Sheet Total Asset", statusKey: "IsBalancesheetTotalAssetCompleted", url: "/balance-sheet-total-assets-consumer" },
  { screenName: "Balance Sheet Total Liability", statusKey: "IsBalancesheetTotalLiabiltyCompleted", url: "/balance-sheet-total-liabilities-consumer" },
  { screenName: "Questionnaire", statusKey: "IsQuestionairCompleted", url: "/questionnaire-consumer" }
];